import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appActions } from "../../../store/app-slice";
import { authActions } from "../../../store/auth-slice";
import { useTranslation } from "react-i18next";
import {
  NotificationsActive,
  Mail as MailIcon,
  Inbox as InboxIcon,
} from "@mui/icons-material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./sidebar.scss";
import {
  faCaretDown,
  faListOl,
  faSignsPost,
  faSitemap,
  faNewspaper,
  faGamepad,
  faImages,
  faTools,
  faLanguage,
  faUserShield,
  faCircleInfo,
  faComments,
  faFileCsv,
  faHome,
  faIcons,
  faEnvelope,
  faBook,
  faTruckFast,
  faBookmark,
  faPeopleGroup,
  faSeedling,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";
import { Badge, Button } from "@mui/material";
import NavLink from "./navlink";
import { Link } from "react-router-dom";


const SidebarComponent = (props) => {
  const { t, i18n } = useTranslation("sidebar");
  const dispatch = useDispatch();
  const uPermission = useSelector((state) => state.auth.userPermission);
  const selectedLanguage = useSelector((state) => state.app.language);
  const webPath = useSelector((state) => state.app.webPath);
  const activateLanguage = useSelector((state) => state.auth.activateLanguage);
  const pagesAllow = useSelector((state) => state.app.pages);
  const uploadPath = useSelector((state) => state.app.uploadPath);
  const isDevMode = useSelector((state) => state.app.isDevMode);
  const mailInbox = useSelector((state) => state.app.mailInbox);
  const contactMs = useSelector((state) => state.app.contactMs);
  const orderPending = useSelector((state) => state.app.orderPending);
  const defaultURL = useSelector((state) => state.app.defaultURL);
  const memberStatus = useSelector((state) => state.app.member);
  const webinfoDetails = useSelector((state) => state.app.webinfo);

  const languageSelectHandler = (lang) => {
    i18n.changeLanguage(lang);
    dispatch(appActions.changeLanguage(lang));
  };

  const toggleSubMenu = (event) => {
    const subMenu = event.target.closest(".has-child");
    subMenu.classList.toggle("opened");
  };

  const closeSidebarhandler = (e) => {
    /* ย่อแถบทำงานเฉพาะ width < 768 */
    let elRoot = document.querySelector("#root");
    if (elRoot && elRoot.offsetWidth <= 900) {
      props.collapseHandler(true);
    }
  };

  const openManual = () => {
    const version = Math.floor(Date.now() / 1000);
    const url = `${uploadPath}upload/manual/manual.pdf?v=${version}`;
    window.open(url, '_blank')
  }
// console.log(webinfoDetails);
  return (
    <aside className="aside">
      <nav>
        <Link className="sidenav-header" to={defaultURL}>
          <figure className="figure-image" style={{marginRight: '2px', marginLeft: '2px'}}>
            <img
              src={uploadPath + webinfoDetails.logo}
              className="website-logo"
            />
          </figure>
          <div className="website-powerby" style={{marginRight: '4px'}}>
            <p>Agro Star Seeds<br/>Company</p>
            <p className="sub-website">{t("Managements")}</p>
          </div>
        </Link>

        <hr className="line-section" />
        <div className="title-section">{t("Languages")}</div>
        <div className="language-selection">
          {activateLanguage.map((lang) => (
            <Button
              variant="outlined"
              key={lang}
              onClick={(e) => languageSelectHandler(lang)}
              className={`btn-lang ${lang.toLowerCase() === selectedLanguage.toLowerCase()
                ? "selected"
                : ""
                }`}
            >
              {lang}
            </Button>
          ))}
        </div>

        <hr className="line-section gap " />
        <div className="sidenav-main">
          {pagesAllow.groups.notify && (
            <Fragment>
              <div className="title-section">{t("NotificationTitle")}</div>
              <ul className="nav-menu">
                {pagesAllow.dashboard && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="dashboard"
                      className="navlink"
                      title={t("dashboardPage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faGamepad} />
                      </figure>
                      <div className="menu-title">{t("dashboardPage")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.messages && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="messages"
                      className={`navlink `}
                      title={t("MessagesPage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faComments} />
                      </figure>
                      <div className="menu-title">{t("MessagesPage")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.orders && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="orders"
                      className={`navlink `}
                      title={t("OrderPage")}
                      liClass="menu-link"
                    >
                      <Badge color="secondary" badgeContent={orderPending}>
                        <NotificationsActive fontSize="small" />
                      </Badge>
                      <div className="menu-title">{t("OrderPage")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.inbox && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="inbox"
                      className={`navlink `}
                      title={t("แจ้งรับบริการ")}
                      liClass="menu-link"
                    >
                      <Badge color="secondary" badgeContent={mailInbox}>
                        <InboxIcon fontSize="small" />
                      </Badge>
                      <div className="menu-title">{t("แจ้งรับบริการ")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.contactMessage && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="contactmessage"
                      className={`navlink `}
                      title={t("ข้อความติดต่อ")}
                      liClass="menu-link"
                    >
                      <Badge color="secondary" badgeContent={contactMs}>
                        <MailIcon fontSize="small" />
                      </Badge>
                      <div className="menu-title">{t("ข้อความติดต่อ")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.shipping && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="shipping"
                      className={`navlink `}
                      title={t("ShippingPage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faTruckFast} />
                      </figure>
                      <div className="menu-title">{t("ShippingPage")}</div>
                    </NavLink>
                  </li>
                )}
                {pagesAllow.subscribe && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="subscribe"
                      className={`navlink `}
                      title={t("SubscribePage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </figure>
                      <div className="menu-title">{t("SubscribePage")}</div>
                    </NavLink>
                  </li>
                )}
              </ul>
            </Fragment>
          )}

          {/* จัดการบทความ */}
          {pagesAllow.groups.article && (
            <Fragment>
              <hr className="line-section gap" />
              <div className="title-section">{t("ManageContent")}</div>
              <ul className="nav-menu">
                {pagesAllow.slides && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="slides"
                    className={`navlink `}
                    title={t("SlidesPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faImages} />
                    </figure>
                    <div className="menu-title">{t("SlidesPage")}</div>
                  </NavLink>
                )}
                <li className={`menu-link has-child opened`}>
                  {/* opened */}
                  <a
                    className={`navlink `}
                    onClick={toggleSubMenu}
                    title={t("ManageWebContent")}
                  >
                    <FontAwesomeIcon
                      icon={faCaretDown}
                      className="toggle-submenu"
                    />
                    <span className="collap-title">
                      <FontAwesomeIcon icon={faListOl} />
                    </span>
                    <div className="menu-title">{t("ManageWebContent")}</div>
                  </a>
                  <div className="child-menu ">
                    <ul className="nav-items ">
                      {pagesAllow.menu && (
                        <NavLink
                          onClick={closeSidebarhandler}
                          to="menu"
                          className={`items `}
                          title={t("ManageWebContent")}
                          liClass="sub-items"
                        >
                          <span className="collap-title">
                            <FontAwesomeIcon icon={faSignsPost} />
                          </span>
                          <span className="menu-title">{t("MenuPage")}</span>
                        </NavLink>
                      )}
                      {pagesAllow.category && (uPermission.superAdmin || uPermission.admin) &&(
                        <NavLink
                          onClick={closeSidebarhandler}
                          to="category"
                          className={`items `}
                          title={t("ManageWebContent")}
                          liClass="sub-items"
                        >
                          <span className="collap-title">
                            <FontAwesomeIcon icon={faSitemap} />
                          </span>
                          <span className="menu-title">
                            {t("ProductCategory")}
                          </span>
                        </NavLink>
                      )}
                      {pagesAllow.posts && (
                        <NavLink
                          onClick={closeSidebarhandler}
                          to="posts"
                          className={`items `}
                          title={t("ManageWebContent")}
                          liClass="sub-items"
                        >
                          <span className="collap-title">
                            <FontAwesomeIcon icon={faNewspaper} />
                          </span>
                          <span className="menu-title">{t("PostPage")}</span>
                        </NavLink>
                      )}
                      {pagesAllow.personnels && (
                        <NavLink
                          onClick={closeSidebarhandler}
                          to="personnels"
                          className={`items `}
                          title={t("PersonnelPage")}
                          liClass="sub-items"
                        >
                          <span className="collap-title">
                            <FontAwesomeIcon icon={faPeopleGroup} />
                          </span>
                          <span className="menu-title">{t("PersonnelPage")}</span>
                        </NavLink>
                      )}
                      {pagesAllow.research && (
                        <NavLink
                          onClick={closeSidebarhandler}
                          to="research"
                          className={`items `}
                          title={t("ResearchPage")}
                          liClass="sub-items"
                        >
                          <span className="collap-title">
                            <FontAwesomeIcon icon={faBookmark} />
                          </span>
                          <span className="menu-title">{t("ResearchPage")}</span>
                        </NavLink>
                      )}
                    </ul>
                  </div>
                </li>
              </ul>
            </Fragment>
          )}

          {/* จัดการสินค้า*/}
          {pagesAllow.productgroups.categories && (
            <Fragment>
              <hr className="line-section gap" />
              <div className="title-section">{t("ManageProducts")}</div>
              <ul className="nav-menu">
                {pagesAllow.productgroups.category && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="ProductsCategories"
                    className={`navlink `}
                    title={t("CategoryPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faSitemap} />
                    </figure>
                    <div className="menu-title">{t("CategoryPage")}</div>
                  </NavLink>
                )}

                {pagesAllow.productgroups.productpage && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="ProductsAgriculture"
                    className={`navlink `}
                    title={t("ProductPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faSeedling} />
                    </figure>
                    <div className="menu-title">{t("ProductPage")}</div>
                  </NavLink>
                )}
              </ul>
            </Fragment>
          )}

          {/* จักการสมาชิก */}
          {pagesAllow.members&&(uPermission.user || uPermission.superAdmin) && (
            <Fragment>
              <hr className="line-section gap" />
              <div className="title-section">{t("ManageMember")}</div>
              <ul className="nav-menu">
                {pagesAllow.productgroups.category && (
                  <li>
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="Members"
                      className={`navlink `}
                      title={t("MembersPage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faUsersGear} />
                      </figure>
                      <div className="menu-title">
                        {t("MembersPage")}
                      </div>
                      <div className="title-notify">
                        <div className="notify-newmember">{memberStatus.pending}</div>
                        <div className="notify-expiremember">{memberStatus.active}</div>
                      </div>

                    </NavLink>

                  </li>
                )}
              </ul>
              <div></div>
            </Fragment>
          )}

          {pagesAllow.groups.report && (
            <Fragment>
              <hr className="line-section gap" />
              <div className="title-section">{t("ReportTitle")}</div>
              <ul className="nav-menu">
                {pagesAllow.reports && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="reports"
                    className={`navlink `}
                    title={t("ReportPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faFileCsv} />
                    </figure>
                    <div className="menu-title">{t("ReportPage")}</div>
                  </NavLink>
                )}
              </ul>
            </Fragment>
          )}

          {pagesAllow.groups.system && (
            <Fragment>
              <hr className="line-section gap" />
              <div className="title-section">{t("SettingsTitle")}</div>
              <ul className="nav-menu">
                {pagesAllow.webinfo && (uPermission.superAdmin||
                    uPermission.admin)&&(
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="webinfo"
                    className={`navlink `}
                    title={t("WebInfoPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </figure>
                    <div className="menu-title">{t("WebInfoPage")}</div>
                  </NavLink>
                )}
                {pagesAllow.admins &&
                  (uPermission.superAdmin ||
                    uPermission.admin ) && (
                    <NavLink
                      onClick={closeSidebarhandler}
                      to="admins"
                      className={`navlink `}
                      title={t("AdminPage")}
                      liClass="menu-link"
                    >
                      <figure className="faIcon">
                        <FontAwesomeIcon icon={faUserShield} />
                      </figure>
                      <div className="menu-title">{t("AdminPage")}</div>
                    </NavLink>
                  )}

                {pagesAllow.languages && (uPermission.superAdmin||
                    uPermission.admin) && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="languages"
                    className={`navlink `}
                    title={t("LanguagePage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faLanguage} />
                    </figure>
                    <div className="menu-title">{t("LanguagePage")}</div>
                  </NavLink>
                )}

                {pagesAllow.configs && uPermission.superAdmin && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="configs"
                    className={`navlink `}
                    title={t("ConfigPage")}
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faTools} />
                    </figure>
                    <div className="menu-title">{t("ConfigPage")}</div>
                  </NavLink>
                )}
                {isDevMode && (
                  <NavLink
                    onClick={closeSidebarhandler}
                    to="componentui"
                    className={`navlink `}
                    title="UI Components"
                    liClass="menu-link"
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faIcons} />
                    </figure>
                    <div className="menu-title">UI Components</div>
                  </NavLink>
                )}
                <div className="menu-link">
                  <a
                    // href={`${uploadPath}upload/manual/manual.pdf`}
                    className={`navlink `}
                    target="_blank"
                    title="Manual"
                    onClick={openManual}
                  >
                    <figure className="faIcon">
                      <FontAwesomeIcon icon={faBook} />
                    </figure>
                    <div className="menu-title">{t("Manual")}</div>
                  </a>
                </div>
              </ul>
            </Fragment>
          )}
        </div>
        <hr className="line-section gap" />
      </nav>
      <ul
        className="nav-menu mini-bar"
        style={{ marginTop: "auto", paddingRight: ".5rem" }}
      >
        <li className="menu-link footerLink">
          <a
            href={webPath}
            target="_blank"
            className="navlink pink-btn "
            title={t("GoToWebSite")}
          >
            <figure className="faIcon">
              <FontAwesomeIcon icon={faHome} />
            </figure>
            <span className="menu-title">{t("GoToWebSite")}</span>
          </a>
        </li>
      </ul>
      <p className="powerBy">Backoffice version 1 </p>
    </aside>
  );
};

export default SidebarComponent;
